module.exports = __webpack_public_path__ + "img/alexandre_tharaud.31e942e6.jpg";